import TEMPLATE_URL from "emun.order/add-commitment-prompt.htm";
import controller from "emun.order/add-commitment-prompt.controller";
import open from "webmodals/open";

export default ({
	size = "xs",
	backdrop = "static",
	placement = "center",
	templateUrl = TEMPLATE_URL,
	product = {},
	title = `Add Commitment...`,
	subTitle =  '',
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			title: () => title,
			subTitle: () => subTitle,
			product: () => product,
		},
	}).result;
